import {Pagination} from '../../../utils/pagination'
import OrderAuditListHeader from '../sections/header/OrderAuditListHeader'
import OrderAuditTable from '../sections/tables/OrderAuditTable'
import {OrderAuditContext} from '../context'
import useGetOrderAuditList from '../hooks/useGetOrderAuditList'
import {useGetSalesRepDropdown} from '../hooks/useGetSalesRepDropdown'
import useGetOrderAuditOprations from '../hooks/useGetOrderAuditOprations'
import {useLocation} from 'react-router-dom'
import usePermission from '../../../hook/usePermission'

const OrderAuditList = () => {
  const location = useLocation()
  const {hasPermission} = usePermission()
  const {
    orderAuditList,
    pagination,
    isLoading,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
    onChangeSalesRepFilter,
  } = useGetOrderAuditList()
  const {salesReps, isLoading: isSalesRepDropdownLoading} = useGetSalesRepDropdown()
  const {onUpdateStatus, isOperationLoading} = useGetOrderAuditOprations()

  const hasWritePermission = hasPermission('orders_order price report', 'write')
  const tabView = new URLSearchParams(location.search).get('view') || ''

  const contextValues = {
    hasWritePermission,
    tabView,
    orderAuditList,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    salesReps,
    isSalesRepDropdownLoading,
    onChangeSalesRepFilter,
    onUpdateStatus,
    isOperationLoading,
  }

  return (
    <OrderAuditContext.Provider value={contextValues}>
      <OrderAuditListHeader />
      <OrderAuditTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </OrderAuditContext.Provider>
  )
}

export default OrderAuditList
